export default "__VITE_ASSET__7a0615bb__"